import { formatInTimeZone, fromZonedTime } from "date-fns-tz";

import { FIELD_STATE, isRequiredFieldState } from "../../utils";
import { LabeledCell } from "./PatientSection";
import SamplerField from "./SamplerField";
import TextInput from "./TextInput";

const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return formatInTimeZone(new Date(dateString), userTimezone, "yyyy-MM-dd'T'HH:mm");
};

const parseDateFromInput = (inputValue) => {
  if (!inputValue) return null;
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return fromZonedTime(new Date(inputValue), userTimezone).toISOString();
};

const SamplingSection = ({ admission, activeFields, onAdmissionChange }) => {
  const isMissing = (state, filled) => isRequiredFieldState(state) && !filled;
  const shouldShowSection = activeFields?.admission?.samplingDate !== FIELD_STATE.DISABLE || activeFields?.admission?.samplerCode !== FIELD_STATE.DISABLE;

  if (shouldShowSection !== true) return null;

  return (
    <div className="mb-4">
      <div className="mb-2">
        <div className="section-title">
          <span>Prélèvement</span>
        </div>
      </div>
      <div className="card relative overflow-hidden">
        <div className="grid grid-cols-2 divide-x divide-gray-100">
          <div className="p-4">
            {activeFields?.admission?.samplingDate !== FIELD_STATE.DISABLE ? (
              <LabeledCell label="Date et heure" dataFocusField="samplingDate" attention={isMissing(activeFields?.admission?.samplingDate, !!admission?.samplingDate)}>
                <TextInput
                  fieldState={activeFields?.admission?.samplingDate}
                  value={formatDateForInput(admission?.samplingDate)}
                  onChange={(e) => onAdmissionChange([{ field: "samplingDate", value: parseDateFromInput(e.target.value) }])}
                  placeholder="Date et heure de prélèvement"
                  type="datetime-local"
                />
              </LabeledCell>
            ) : null}
          </div>
          <div className="p-4">
            {activeFields?.admission?.samplerCode !== FIELD_STATE.DISABLE ? (
              <LabeledCell
                label="Préleveur"
                dataFocusField="samplerCode"
                attention={isMissing(activeFields?.admission?.samplerCode, !!(admission?.samplerCode || admission?.laboratory?.samplerCode))}
              >
                <SamplerField
                  code={admission?.samplerCode || ""}
                  inheritedCode={admission?.laboratory?.samplerCode || ""}
                  inheritedLabel="Défaut labo"
                  onChange={(samplerCode) => onAdmissionChange([{ field: "samplerCode", value: samplerCode }])}
                  fieldState={activeFields?.admission?.samplerCode}
                />
              </LabeledCell>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SamplingSection;
